var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinter21Large(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M16,38.9994 L32,38.9994 M16,34.9994 L32,34.9994 M16,30.9994 L32,30.9994 M13,43 L35,43 L35,27 L13,27 L13,43 Z M13,32.9994 L5,32.9994 L5,14.9994 L13,14.9994 L43,14.9994 L43,32.9994 L35,32.9994 M13.001,14.9994 L13.001,6.9994 L35.001,6.9994 L35.001,14.9994"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter21Large);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3e %3cpath fill='none' stroke='%23000' stroke-width='2' d='M16,38.9994 L32,38.9994 M16,34.9994 L32,34.9994 M16,30.9994 L32,30.9994 M13,43 L35,43 L35,27 L13,27 L13,43 Z M13,32.9994 L5,32.9994 L5,14.9994 L13,14.9994 L43,14.9994 L43,32.9994 L35,32.9994 M13.001,14.9994 L13.001,6.9994 L35.001,6.9994 L35.001,14.9994'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };